import Checkers from './class/Checkers';
import {useEffect, useState} from "react";
import {setBedrooms} from "../redux/actions";
import {useSelector} from "react-redux";

export const scrollToAnchor = ( hash: string, behavior: ScrollBehavior = 'smooth' ) => {
  if ( typeof document === 'undefined' || !hash ) return false

  const target = document.getElementById( hash )
  if ( !target ) return false

  const header = document.querySelector( 'header' )
  const headerHeight = header ? header.getBoundingClientRect().height : 0

  let stickyExtra = 0
  document.querySelectorAll( '.searchbar-bg-color' ).forEach( ( el ) => {
    const style = window.getComputedStyle( el )
    if ( style.position === 'fixed' || style.position === 'sticky' ) {
      const rect = el.getBoundingClientRect()
      if ( rect.top <= headerHeight + 5 ) {
        stickyExtra = Math.max( stickyExtra, rect.height )
      }
    }
  } )

  const offset = headerHeight + stickyExtra + 16
  const top = target.getBoundingClientRect().top + window.scrollY - offset

  window.scrollTo( { top, behavior } )
  history.replaceState( window.history.state, '', '#' + hash )

  return true
}

export const hexToRgb = ( hex ) => {
  let c;
  if ( /^#([A-Fa-f0-9]{3}){1,2}$/.test( hex ) ) {
    c= hex.substring( 1 ).split( '' );
    if ( c.length== 3 ) {
      c= [ c[0], c[0], c[1], c[1], c[2], c[2] ];
    }
    c= '0x'+c.join( '' );
    return [ ( c>>16 )&255, ( c>>8 )&255, c&255 ].join( ',' );
  }
  return 0;
}

export const initManifest = ( head, app, start_url ) => {

  const title = Checkers.objChildExists( head, 'data' ) && Checkers.objChildExists( head.data, 'title' ) ? head.data.title : '';
  const motto = Checkers.objChildExists( head, 'data' ) && Checkers.objChildExists( head.data, 'motto' ) ? head.data.motto : '';
  const designColor = Checkers.objChildExists( app, 'designColor' ) ? app.designColor : '';

  if ( Object.keys( head ).length > 0 ) {
    return {
      "$schema": "https://json.schemastore.org/web-manifest-combined.json",
      "allOf": [
        { "$ref": "https://json.schemastore.org/web-manifest.json" },
        { "$ref": "https://json.schemastore.org/web-manifest-app-info.json" },
        { "$ref": "https://json.schemastore.org/web-manifest-share-target.json" }
      ],
      "id": "/?source=pwa",
      "name":  `${title}`,
      "short_name": `${title}`,
      "start_url": `${start_url}`,
      "display": "standalone",
      "background_color": "#fafafa",
      "orientation": "any",
      "theme_color": `${designColor}`,
      "description": `${motto}`,
      "icons": []
    };
  }
}

export const extendManifest = ( manifest, head? ) => {

  const icon_60 = Checkers.objChildExists( head, 'data' ) && Checkers.objChildExists( head.data, 'icon_60' ) ? head.data.icon_60 : '';
  const icon_76 = Checkers.objChildExists( head, 'data' ) && Checkers.objChildExists( head.data, 'icon_76' ) ? head.data.icon_76 : '';
  const icon_120 = Checkers.objChildExists( head, 'data' ) && Checkers.objChildExists( head.data, 'icon_120' ) ? head.data.icon_120 : '';
  const icon_152 = Checkers.objChildExists( head, 'data' ) && Checkers.objChildExists( head.data, 'icon_152' ) ? head.data.icon_152 : '';
  const icon_256 = Checkers.objChildExists( head, 'data' ) && Checkers.objChildExists( head.data, 'icon_256' ) ? head.data.icon_256 : '';
  const icon = Checkers.objChildExists( head, 'data' ) && Checkers.objChildExists( head.data, 'icon' ) ? head.data.icon : '';

  if ( icon_60 != null && icon_60 != '' ) {
    manifest.icons.push(
      {
        "src": `${icon_60}`,
        "sizes": "60x60",
        "type": "image/png",
        "purpose": "maskable"
      }
    );

  }
  if ( icon_76 != null && icon_76 != '' ) {
    manifest.icons.push(
      {
        "src": `${icon_76}`,
        "sizes": "76x76",
        "type": "image/png",
        "purpose": "maskable"
      }
    );

  }
  if ( icon_120 != null && icon_120 != '' ) {
    manifest.icons.push(
      {
        "src": `${icon_120}`,
        "sizes": "120x120",
        "type": "image/png",
        "purpose": "maskable"
      }
    );

  }
  if ( icon_152 != null && icon_152 != '' ) {
    manifest.icons.push(
      {
        "src": `${icon_152}`,
        "sizes": "152x152",
        "type": "image/png",
        "purpose": "maskable"
      }
    );

  }
  if ( icon_256 != null && icon_256 != '' ) {
    manifest.icons.push(
      // {
      // 	"src": `${icon_256}`,
      // 	"sizes": "192x192",
      // 	"type": "image/png",
      // 	"purpose": "maskable"
      // },
      {
        "src": `${icon_256}`,
        "sizes": "256x256",
        "type": "image/png",
        "purpose": "any"
      }
    );

  }
  if ( icon != null && icon != '' ) {
    manifest.icons.push(
      {
        "src": `${icon}`,
        "sizes": "1024x1024",
        "type": "image/png",
        "purpose": "maskable"
      }
    );
  }

  return manifest;
}

export const getPropertyPricingData = ( propertyId, pricingData: any, fetchWebhotelierPrices ) => {
    if(pricingData==null){
        return null
    }

    if(!fetchWebhotelierPrices){
        return null
    }

    let propertyPrice = pricingData.filter(item => item.propertyId === propertyId)

    if(Checkers.isValidArray(propertyPrice)){
        let singlePrice = propertyPrice[0]
        if(Checkers.isValidPositiveNumber(singlePrice.price)){
            return singlePrice
        }
        return null
    }

    return null
}

export const getBedroomPricingData = ( bedroomId, pricingData: any, fetchWebhotelierPrices ) => {
  if(pricingData==null){
      return null
  }

  if(!fetchWebhotelierPrices){
      return null
  }

  let bedroomPrice = pricingData.filter(item => item.bedroomId === bedroomId)

  if(Checkers.isValidArray(bedroomPrice)){
      let singlePrice = bedroomPrice[0]
      if(Checkers.isValidPositiveNumber(singlePrice.price)){
          return singlePrice
      }
      return null
  }

  return null
}


export const fetchBuilderSettingByKey = (builderSettingsData : any, key: string, defaultValue = null) => {
    if ( builderSettingsData==null || builderSettingsData==undefined ) {
        return defaultValue;
    }
    if ( builderSettingsData['settings']==null || builderSettingsData['settings']==undefined ) {
        return defaultValue;
    }

    if(builderSettingsData['settings'][key]!=undefined){
        return builderSettingsData['settings'][key]
    }

    return builderSettingsData['settings']['builder'][key]
}

export const useWindowSize = () => {
    // Initialize state with undefined width/height so server and client renders match
    // Learn more here: https://joshwcomeau.com/react/the-perils-of-rehydration/
    const [windowSize, setWindowSize] = useState({
        width: undefined,
        height: undefined,
    });

    useEffect(() => {
        // only execute all the code below in client side
        // Handler to call on window resize
        function handleResize() {
            // Set window width/height to state
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight,
            });
        }

        // Add event listener
        window.addEventListener("resize", handleResize);

        // Call handler right away so state gets updated with initial window size
        handleResize();

        // Remove event listener on cleanup
        return () => window.removeEventListener("resize", handleResize);
    }, []); // Empty array ensures that effect is only run on mount
    return windowSize;
}


export const randomCoordinateFactor = () => {
    return Math.random()/100
}

export const textColor = (darkMode) => {
    if (darkMode === true || darkMode === "1") {
        return "text-light-color"
    }

    return '';
}

export const btnTextColor = (darkMode) => {
    if (darkMode === true || darkMode === "1") {
        return "text-white"
    }

    return 'text-black';
}

export const isDarkMode = (darkMode) => {
    if (darkMode === true || darkMode === "1") {
        return true
    }

    return false;
}

export const updateBedrooms = (value, setterFunction) => {
    if (value.hasOwnProperty('value')) {
        if(value.value=='all'){
            setterFunction(0)
        } else {
            setterFunction(value.value)
        }

        console.log("newValue", value.value)
    }
}

export const getBedroomValue = (bedrooms, bedroomOptions) => {
    let value = null;

    bedroomOptions.forEach( (item) => {
        if(item.value == bedrooms){
            value = item
        }
    })

    return value
}

export const getUnavailablePropertiesOpacity = (availabilityStatus, unavailablePropertiesOpacity) => {
    return availabilityStatus==0 && Checkers.isValidNumber(unavailablePropertiesOpacity) ? unavailablePropertiesOpacity : 1
}

export const getPropertyViewType = (availabilityStatus, propertiesViewType, unavailabelPropertiesViewType) => {
    if(availabilityStatus==null){
        return propertiesViewType
    }

    if(availabilityStatus==1){
        return propertiesViewType
    }

    if(availabilityStatus==0){
        return unavailabelPropertiesViewType
    }

    return propertiesViewType
}

export const enableBookingBtn = (propertyInitialAvailability, priceLoading, personsForBooking, dateRangeValid) => {
    return (propertyInitialAvailability || priceLoading) && Checkers.isValidPositiveNumber(personsForBooking) && dateRangeValid
}

export const getHomepageUrl = (defaultUrl, useRedirectUrl, homePageUrl) => {
    if(useRedirectUrl && Checkers.isValidString(homePageUrl)){
        return (Checkers.isValidString(process.env.SCHEME) ? process.env.SCHEME : "https://") + homePageUrl;
    }

    return defaultUrl
}

export function queryStringToObject(queryString: string) {
    return new URLSearchParams(queryString);
}

type QueryValue =
    | string
    | number
    | boolean
    | null
    | undefined
    | string[]
    | number[]
    | boolean[]

export function cleanQuery<T extends Record<string, QueryValue>>(filters: T) {
    return Object.fromEntries(
        Object.entries(filters).filter(([_, value]) => {
            if (value === null || value === undefined) return false
            if (typeof value === "string" && value.trim() === "") return false
            if (Array.isArray(value) && value.length === 0) return false
            return true
        })
    )
}
// HTML sections can embed the same Elfsight widget more than once (duplicate entries in the builder);
// Elfsight would then show it twice (two cookie bars, two popups), so keep only the first section per widget id.
export const uniqueElfsightSections = ( sections: any[] ) => {
  const seen = new Set<string>()
  return ( Array.isArray( sections ) ? sections : [] ).filter( ( section ) => {
    const match = typeof section?.app_section_content === 'string' ? section.app_section_content.match( /elfsight-app-([\w-]+)/ ) : null
    if ( match == null ) {
      return true
    }
    if ( seen.has( match[1] ) ) {
      return false
    }
    seen.add( match[1] )
    return true
  } )
}

// Builder text settings that usually keep their default English value (e.g. the search button's "Search").
// The default is treated as "not customised" so the caller falls back to the translated UI text; a text the
// site owner changed is kept as it is.
export const customBuilderLabel = ( value: any, defaults: string[] ) => {
  if ( typeof value !== 'string' || value.trim().length === 0 ) {
    return null
  }
  const normalized = value.trim().toLowerCase()
  return defaults.some( ( d ) => d.toLowerCase() === normalized ) ? null : value
}

// default English values of builder_properties_search_btn_label
export const SEARCH_BUTTON_DEFAULT_LABELS = [ 'Search', 'Find Hotels' ]

// default English values of builder_properties_select_label
export const SELECT_LABEL_DEFAULT_LABELS = [ 'Location/Property', 'Location / Property' ]

// default English value of builder_properties_inquires_label
export const UPON_REQUEST_DEFAULT_LABELS = [ 'Upon request' ]

// mount point (in BottomSections, above the footer) for the Elfsight widgets of the "end of body" sections
export const BODY_END_WIDGETS_ID = 'body-end-widgets'
